export default __webpack_public_path__ + "static/mobile-bg-top-leaves-90b7f4e404b0b93bd5661cfb19c26203.png";